export default {
  isRedesign(state) {
    return state.uiMode === 'redesign';
  },
  needEmailVerification(state) {
    return (
      !state.disableEmailVerification &&
      !state.skipEmailVerification &&
      state.isEmailVerified === '0' &&
      state.isPaidAccount === '0'
    );
  },
  currentMethod(state) {
    return state.choseMethod || state.defaultMethod;
  },
  hasBackup(state) {
    return state.availableMethod.length > 1;
  },
  otherMethods(state) {
    const availableMethods = [...state.availableMethod];
    availableMethods.shift();
    return availableMethods;
  },
  allowSocialAuth(state) {
    if (state.supportAuthMethod.length > 0 && !state.supportAuthMethod.join().includes('social')) {
      return false;
    }
    return true;
  },
  supportSocialApple(state) {
    if (state.supportAuthMethod.length > 0 && !state.supportAuthMethod.includes('social-apple')) {
      return false;
    }
    return true;
  },
  supportSocialGoogle(state) {
    if (state.supportAuthMethod.length > 0 && !state.supportAuthMethod.includes('social-google')) {
      return false;
    }
    return true;
  },
  supportInappPolling(state) {
    return state.supportInappPolling;
  },
  supportSocialLine(state) {
    if (state.showOldSsoUi) {
      return false;
    }
    if (!state.supportLineOauth) {
      return false;
    }
    if (state.supportAuthMethod.length > 0 && !state.supportAuthMethod.includes('social-line')) {
      return false;
    }
    return true;
  },
  reAuthHasAppleAccount(state) {
    if (state.supportAuthMethod.length > 0) {
      return state.supportAuthMethod.includes('social-apple');
    }
    return false;
  },
  reAuthHasGoogleAccount(state) {
    if (state.supportAuthMethod.length > 0) {
      return state.supportAuthMethod.includes('social-google');
    }
    return false;
  },
  reAuthHasLineAccount(state) {
    if (state.showOldSsoUi) {
      return false;
    }
    if (!state.supportLineOauth) {
      return false;
    }
    if (state.supportAuthMethod.length > 0) {
      return state.supportAuthMethod.includes('social-line');
    }
    return false;
  },
  reAuthHasSocialAccount(state, getters) {
    return getters.reAuthHasAppleAccount || getters.reAuthHasGoogleAccount || getters.reAuthHasLineAccount;
  },
  reAuthHasPasswordAuth(state) {
    if (state.supportAuthMethod.length > 0) {
      return state.supportAuthMethod.includes('password');
    }
    return false;
  },
  checkAccountHasPasswordAuth(state) {
    if (state.checkAccountSupportAuthMethod.length > 0) {
      return state.checkAccountSupportAuthMethod.includes('password');
    }
    return false;
  },
};
